import { load3DLogo } from '../../vendor/index.js';

export default {
  init() {
    $(document).ready(function () {
      $('.blocks .block_wrapper .block_black').each(function () {


        $(this).bind('mouseenter', function (e) {
          $(this).find('.block_content_black').fadeOut(250);
          $(this).find('.block_content_white').css("display", "flex")
          $(this).find('.block_content_white').fadeIn(250);
          //este codigo esta para arreglar la parte mobile de mouse in and mause out
          // if (jQuery(window).width() <= 425) {
          //   $(this).find('.block_content_white').css("position", "relative")
          //   $(this).find('.block_content_white').css("width", "100%")
          //   $(this).find('.block_content_white').css("min-height", "340px")
          // }
        });

        $(this).bind('mouseleave', function (e) {
          $(this).find('.block_content_white').fadeOut(250);
          $(this).find('.block_content_black').fadeIn(250);
        });
      });
    });
  },
};


